/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

//---------------------------------------------------------------------
// Colour can only be used with the first param of a call to console.*
//     (log, info, debug, etc)
//     Example: only string1 will work with color
//     $ console.debug(string1, string2, object3)
//---------------------------------------------------------------------

// export const addColor = (colorCode, message) => {
//     const open = `\u001b[${colorCode}m`;
//     const close = "\u001b[0m";
//     return `${open}${message}${close}`;
// };

export const stripAnsiCodes = (message) => {
    // eslint-disable-next-line no-control-regex
    return message.replace(/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, "");
};

export const ANSI_COLORS = {
    black: "30",
    red: "31",
    green: "32",
    yellow: "33",
    blue: "34",
    magenta: "35",
    cyan: "36",
    white: "37",
    gray: "90",
    grey: "90",
    blackBright: "90",
    redBright: "91",
    greenBright: "92",
    yellowBright: "93",
    blueBright: "94",
    magentaBright: "95",
    cyanBright: "96",
    whiteBright: "97"
};

export const WEB_COLORS = {
    black: "#000000",
    red: "#B00000",
    green: "#008000",
    yellow: "#999900",
    blue: "#000080",
    magenta: "#990099",
    cyan: "#009999",
    white: "#F4F4F4",
    gray: "#C0C0C0",
    grey: "#C0C0C0",
    blackBright: "#808080",
    redBright: "#DD0000",
    greenBright: "#22CC22",
    yellowBright: "#CCCC00",
    blueBright: "#0000FF",
    magentaBright: "#CC00CC",
    cyanBright: "#00FFFF",
    whiteBright: "#FFFFFF"
};

export const addColor = (colorName, message) => {
    // global document exists only in browser
    if (document) {
        const color = WEB_COLORS[colorName] ?? WEB_COLORS["grey"];
        const args = [`%c${message}`, `color: ${color}`];
        // console.log(...args);
        return args;
    }
    const color = ANSI_COLORS[colorName] ?? ANSI_COLORS["grey"];
    const open = `\u001b[${color}m`;
    const close = "\u001b[0m";
    return [`${open}${message}${close}`];
};

const darkModeMediaQuery = window?.matchMedia("(prefers-color-scheme: dark)");

export const isDarkMode = () => {
    return window && window?.matchMedia && darkModeMediaQuery?.matches;
};

darkModeMediaQuery.addEventListener("change", (event) => {
    if (event?.matches) {
        console.log("Switched to dark mode!");
    } else {
        console.log("Switched to light mode!");
    }
});


export const black = (message) => addColor("black", message);
export const red = (message) => addColor("red", message);
export const green = (message) => addColor("green", message);
export const yellow = (message) => addColor("yellow", message);
export const blue = (message) => addColor("blue", message);
export const magenta = (message) => addColor("magenta", message);
export const cyan = (message) => addColor("cyan", message);
export const white = (message) => addColor("white", message);
export const gray = (message) => addColor("gray", message);
export const grey = (message) => addColor("grey", message);
export const blackBright = (message) => addColor("blackBright", message);
export const redBright = (message) => addColor("redBright", message);
export const greenBright = (message) => addColor("greenBright", message);
export const yellowBright = (message) => addColor("yellowBright", message);
export const blueBright = (message) => addColor("blueBright", message);
export const magentaBright = (message) => addColor("magentaBright", message);
export const cyanBright = (message) => addColor("cyanBright", message);
export const whiteBright = (message) => addColor("whiteBright", message);

export const colors = {
    black,
    red,green,
    yellow,
    blue,
    magenta,
    cyan,
    white,
    gray,
    grey,
    blackBright,
    redBright,
    greenBright,
    yellowBright,
    blueBright,
    magentaBright,
    cyanBright,
    whiteBright
};
